export const maintenanceEn = {
  maintenance: {
    filters: {
      cities: 'Cities',
      properties: 'Properties',
      removeFilters: 'Remove Filters',
      status: 'Status',
    },
    modal: {
      address: 'Address',
      adminNotes: 'Admin Notes',
      building: 'Building',
      buildingInformation: 'BUILDING INFORMATION',
      category: 'Category',
      city: 'City',
      contactInformation: 'CONTACT INFORMATION',
      customFields: 'Custom Fields',
      dateSent: 'Date Sent',
      deleteRequest: 'Delete Request',
      email: 'Email',
      formName: 'Form Name',
      phone: 'Phone',
      requestedBy: 'Requested by',
      timeSent: 'Time Sent',
      unit: 'Unit',
      workDetails: 'WORK DETAILS',
      workOrder: 'Work Order',
    },
    placeholders: {
      selectProperties: 'Select Properties',
      selectStatuses: 'Select Statuses',
    },
    maintenanceRequest: 'Maintenance Request',
    requestDetails: 'Request Details',
    exportMessage: 'Generating maintenance request export',
    exportFile: 'maintenance_requests',
    deleteRequestTitle: 'Delete Maintenance Request',
    deleteRequestConfirm: 'Are you sure you want to delete this maintenance request?',
    deleteRequestConfirmPrefix: 'Are you sure you want to delete maintenance request',
    actionCannotBeUndone: 'This action cannot be undone.',
    requestDeleted: 'Maintenance request has been deleted!',
  },
} as const;

export const maintenanceFr = {
  maintenance: {
    filters: {
      cities: 'Villes',
      properties: 'Propriétés',
      removeFilters: 'Effacer les filtres',
      status: 'Statut',
    },
    modal: {
      address: 'Addresse',
      adminNotes: 'Notes administratives',
      building: 'Propriété',
      buildingInformation: 'INFORMATIONS SUR LA PROPRIÉTÉ',
      category: 'Catégorie',
      city: 'Ville',
      contactInformation: 'COORDONNÉES',
      customFields: 'Champs personnalisés',
      dateSent: 'Date d\'envoi',
      deleteRequest: 'Supprimer la demande',
      email: 'Courriel',
      formName: 'Nom du formulaire',
      phone: 'Téléphone',
      requestedBy: 'Demandé par',
      timeSent: 'Heure d\'envoi',
      unit: 'Unité',
      workDetails: 'DÉTAILS DES TRAVAUX',
      workOrder: 'Ordre de travail',
    },
    placeholders: {
      selectProperties: 'Sélectionner des propriétés',
      selectStatuses: 'Sélectionner des statuts',
    },
    maintenanceRequest: 'Demande d\'entretien',
    requestDetails: 'Description de la demande',
    exportMessage: 'Export des demandes de maintenance en cours de génération',
    exportFile: 'demandes_maintenance',
    deleteRequestTitle: 'Supprimer la demande d\'entretien',
    deleteRequestConfirm: 'Voulez-vous vraiment supprimer cette demande d\'entretien?',
    deleteRequestConfirmPrefix: 'Voulez-vous vraiment supprimer la demande d\'entretien',
    actionCannotBeUndone: 'Cette action est irréversible.',
    requestDeleted: 'La demande d\'entretien a été supprimée!',
  },
} as const;
